// Shopify.money_format = "£{{amount}}";

$(function() {})